<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>

    <!-- Modal Component -->
    
    <b-row>
      <b-col sm="12">
        <div>
          <b-card :title="procedeOrden ? 'Antes de continuar, llene y verifique los siguientes datos:' : ''"
                  tag="article"
                  class="mb-2">
            <b-row>

              <b-col sm="12" md="12" lg="6">
                <b-card header="Información de pago">
                  <!-- <b-card-title>Información de pago</b-card-title> -->
                  <b-card-body>
                    <b-table stacked bordered :items="tabla"></b-table>
                  </b-card-body>

                  <!-- <b-card-title>
                    Realizar mi pago en la practi-caja o aplicación móvil
                    <b-img src="/img/brand/bbva.jpg" width="80px"/>
                  </b-card-title>

                  <h6>Convenio: <strong>1766589</strong></h6>
                  <h6>Referencia: <strong>{{tabla[0].referencia}}</strong></h6> -->
                  
                  
<!--                   
                  <b-card-body>
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="facturacion.requiere"
                      name="checkbox-1"
                      :unchecked-value="false"
                    >
                      Requiero factura
                    </b-form-checkbox>
                    <div>
                      <label for="input-live">RFC:</label>
                      <b-form-input
                        id="input-live"
                        v-model="facturacion.rfc"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese RFC"
                        trim
                        :disabled="!facturacion.requiere"
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Nombre:</label>
                      <b-form-input
                        id="input-live"
                        v-model="facturacion.nombre"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese nombre"
                        trim
                        :disabled="!facturacion.requiere"
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Domicilio:</label>
                      <b-form-input
                        id="input-live"
                        v-model="facturacion.domicilio"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese domicilio"
                        trim
                        :disabled="!facturacion.requiere"
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Colonia:</label>
                      <b-form-input
                        id="input-live"
                        v-model="facturacion.colonia"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese colonia"
                        trim
                        :disabled="!facturacion.requiere"
                      ></b-form-input>
                    </div>
                    <div>
                      <label for="input-live">Estado:</label>
                      <b-form-input
                        id="input-live"
                        v-model="facturacion.estado"
                        aria-describedby="input-live-help input-live-feedback"
                        placeholder="Ingrese estado"
                        trim
                        :disabled="!facturacion.requiere"
                      ></b-form-input>
                    </div>
                  </b-card-body> -->



                </b-card>
              </b-col>

               <b-col v-if="procedeOrden" sm="12" md="12" lg="6">
                <b-card v-if="tokenValido">
                  <b-card-title>Realizar mi pago en línea</b-card-title>
                  <b-card-body v-if="tokenValido && procedeOrden">
                      <div role="group">
                        <label for="inputLive"><b>* Correo electrónico:</b></label>
                        <b-form-input id="inputLive"
                              v-model.trim="correo"
                              type="text"
                              name="correo"
                              :state="correoValido"
                              placeholder="Ingrese su correo...">
                        </b-form-input>
                        <i>A esta direcicón será enviada la orden generada para darle seguimiento.</i>
                    </div>
                  </b-card-body>
                  <b-card-body>
                    <h6><b-badge variant="primary"><i class="fa fa-check"></i></b-badge>
                     1. Información de cuenta correcta
                    </h6>
                    <br>
                    <h6><b-badge variant="primary"><i class="fa fa-check"></i></b-badge>
                    2. Página segura:
                    </h6>
                    <br>
                    <b-img src="/img/https.png" center/>
                  </b-card-body>
                  <b-card-body>
                    <h6><b-badge variant="primary"><i class="fa fa-check"></i></b-badge>
                    3. Página correcta:
                    </h6>
                    <br>
                    <h4 class="text-center">https://pagos.elsalto.gob.mx</h4>
                  </b-card-body>
                  <b-card-body>
                      <b-form-checkbox id="checkbox1"
                            v-model="verificado"
                            value="accepted"
                            unchecked-value="not_accepted">
                        He verificado que todos los datos son correctos
                        </b-form-checkbox>
                  </b-card-body>
                  <b-card-body>
                      <b-button variant="success" :disabled="!datosValidados ? true : false" @click="realizarEncuesta()">Pagar</b-button>
                      <b-button variant="secondary" class="pull-right" @click="cancelar()">Cancelar</b-button>
                  </b-card-body>
                </b-card>
                <b-card v-else>
                    <b-card-body>
                        <b-alert show variant="danger">
                            <i class="fa fa-times-circle"></i> La sesión ha caducado. Favor de realizar nuevamente la consulta.
                            </b-alert>
                    </b-card-body>
                    <b-card-body>
                      <b-button variant="secondary" class="pull-right" @click="cancelar()">Cancelar</b-button>
                  </b-card-body>
                </b-card>

              </b-col>

              <b-col v-if="!procedeOrden" sm="12" md="12" lg="6">
                <b-card>
                  <b-card-body>
                    <b-alert show variant="warning"><b><i class="fa fa-warning"></i></b> Orden de pago en proceso</b-alert>
                    <p>Estimado usuario, este pago se encuentra en proceso de validación.</p>
                    <p>Le recordamos que el proceso puede durar de dos a tres días hábiles.</p>
                    <p><b>¿Tiene alguna duda?</b><br>
                      Puede contactarnos al teléfono 32841240 ext. 167
                    </p>
                  </b-card-body>
                  <b-card-body>
                    <b-button variant="secondary" class="pull-right" @click="cancelar()">Regresar</b-button>
                  </b-card-body>

                </b-card>
              </b-col>

            </b-row>
          </b-card>

            <!-- <form action="https://prepro.adquiracloud.mx/clb/endpoint/municipioDeElSalto/" ref="pagar" method="POST" target="_self"> -->
              <!-- <input type="hidden" name="mp_account" value="7923"> -->
            <form action="https://www.adquiramexico.com.mx/clb/endpoint/municipioDeElSalto" ref="pagar" method="POST" target="_self">
              <input type="hidden" name="mp_account" value="8614">
              <input type="hidden" name="mp_product" value="1">
              <input type="hidden" name="mp_order" ref="orden" value="">
              <input type="hidden" name="mp_reference" ref="referencia" value="">
              <input type="hidden" name="mp_node" value="0">
              <input type="hidden" name="mp_concept" ref="concepto" value="">
              <input type="hidden" name="mp_amount" ref="importe" value="">
              <input type="hidden" name="mp_customername" ref="nombre" value="">
              <input type="hidden" name="mp_currency" value="1">
              <input type="hidden" name="mp_signature" ref="firma" value="">
              <input type="hidden" name="mp_urlsuccess" ref="success" value="">
              <input type="hidden" name="mp_urlfailure" ref="failure" value="">
            </form>

        </div>
      </b-col>
    </b-row>
    
    <!-- ENCUESTA -->
    <b-modal v-if="encuesta" v-model="mostrarEncuesta" size="xl"
    hide-footer
    >
      <encuesta-presupuesto 
        :encuesta="encuesta"
        :cuenta="cuenta"
        :token="tokenPago"
        @realizarPago="realizarPago"
      />
    </b-modal>
  </div>
</template>

<script>

import axios from "axios";
import { mapGetters } from "vuex";
import Loader from './Loader'
import EncuestaPresupuesto from './encuestaPresupuesto'

const numeral = require('numeral');

export default {
  name: 'RealizarPago',
  components: {
    Loader,
    EncuestaPresupuesto
  },
  computed:{
    ...mapGetters([
      "httpURL"
    ]),
    correoValido(){ 
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(this.correo).toLowerCase());
    },
    datosValidados(){
        if(this.verificado == 'not_accepted' || !this.correoValido)
            return false;
        else 
            return true;
    },
    procedeOrden(){
      if( !this.ordenPrevia )
        return true;
      else{
        if( this.ordenPrevia.status === 3 || this.ordenPrevia.status === 4 )
          return false;
        else  
          return true;
      }
    }
  },
  data: function () {
    return {
      enviando: false,
      verificado: 'not_accepted',
      tokenConsulta: this.$route.params.id,
      tokenPago: null,
      tokenValido: true,
      ordenPago:{},
      correo: null,
      ordenPrevia: null,
      tabla:[{
          cuenta: '',
          nombre: '',
          concepto: '',
          referencia: '',
          importe: '',
      }],
      facturacion:{
        requiere: false,
        rfc: null,
        nombre: null,
        domicilio: null,
        colonia: null,
        estado: null
      },
      encuesta: null,
      mostrarEncuesta: false,
      cuenta: null
    }
  },
  created(){
      this.enviando = true;
        axios.get(this.httpURL+'/operacion/consultar/operacion/'+this.tokenConsulta)
          .then(res => {
              // console.log(res.data);
            //this.operacion = res.data.operacion;
            this.tokenPago = res.data.token;
            this.tabla[0].cuenta = res.data.datos.cuenta;
            this.tabla[0].nombre = res.data.datos.nombre;
            this.tabla[0].concepto = res.data.datos.concepto;
            this.tabla[0].referencia = res.data.datos.referencia;
            this.tabla[0].importe = this.moneda(res.data.datos.adeudo);
            this.ordenPrevia = res.data.orden;
            this.encuesta = res.data.encuesta;
            this.cuenta = res.data.datos.cuenta;
            this.enviando = false;
          })
          .catch(error => {
              //console.log(error);
              this.error = true;
              this.enviando = false;
              this.tokenValido = false;
              //this.$router.push('/consulta');
          });
  },
  methods: {
    moneda(cantidad){
        return numeral(cantidad).format('$0,0.00');
    },
    realizarEncuesta(){
      if( this.encuesta == null )
        this.realizarPago();
      else
        this.mostrarEncuesta = true;
    },
    realizarPago(){
      this.mostrarEncuesta = false;
        this.enviando = true;
        axios.post(this.httpURL+'/operacion/orden',
        {cToken: this.tokenPago, correo: this.correo})
          .then(res => {
              //console.log(res.data);
              let token = res.data.token;
              let orden = res.data.orden;
              this.$refs.orden.value = orden.orden;
              this.$refs.referencia.value = orden.referencia;
              this.$refs.concepto.value = orden.division;
              this.$refs.importe.value = orden.importe;
              this.$refs.nombre.value = orden.nombre;
              this.$refs.firma.value = res.data.firma;
              this.$refs.nombre.value = orden.nombre;
              
              this.$refs.success.value = 'https://elsalto.gob.mx/pago-resultado';
              this.$refs.failure.value = 'https://elsalto.gob.mx/pago-resultado';

              //console.log('Enviando:');
              //console.log(this.$refs.pagar);

              this.$refs.pagar.submit();
              //this.enviando = false;

          })
          .catch(error => {
              //console.log(error);
              this.enviando = false;
              this.tokenValido = false;
          });
    },
    cancelar(){
        this.$router.go(-1);
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
